import * as fromSmsBlast from '../actions/sms-blast.action';

export interface SmsBlastState {
  loaded: Boolean;
  loading: Boolean;
  data: any;
  error: string;
};

export const initialState = {
  loaded: false,
  loading: false,
  data: null,
  error: null
};

export function reducer(state = initialState, action: fromSmsBlast.SmsBlastAction): SmsBlastState {
  switch (action.type) {
    case fromSmsBlast.ADD_SMS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        data: action.payload,
        error: null
      };
    }
    case fromSmsBlast.ADD_SMS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    }
    case fromSmsBlast.ADD_SMS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        data: null,
        error: action.payload
      };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/reducers/sms-blast.reducer.ts